import React from "react";
import { observer } from "mobx-react";
import SectionSources from "./SectionSources";

const ANGLE_BADGES = {
  past_experience: { label: "Past Experience", color: "#7c3aed" },
  competitor: { label: "Competitor", color: "#dc2626" },
  their_words: { label: "Their Words", color: "#2563eb" },
  timing: { label: "Timing", color: "#d97706" },
  insider: { label: "Insider", color: "#059669" },
  glassdoor: { label: "Glassdoor", color: "#ea580c" },
  customer: { label: "Customer", color: "#0891b2" },
  job_posting: { label: "Job Posting", color: "#4f46e5" },
  seller_competitor: { label: "Seller Competitor", color: "#be185d" }
};

const CONFIDENCE_STYLES = {
  high: { bg: "#dcfce7", color: "#166534", label: "High" },
  medium: { bg: "#fef9c3", color: "#854d0e", label: "Med" },
  low: { bg: "#fee2e2", color: "#991b1b", label: "Low" }
};

const ConversationStarters = observer(({ starters, serpLinks }) => {
  if (!starters || starters.length === 0) return null;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="drSection">
      <div className="drSectionHeader">
        <span className="drSectionIcon">💬</span>
        <h3>Conversation Starters</h3>
        <span className="drSectionCount">{starters.length}</span>
      </div>
      <div className="drStartersList">
        {starters.map((starter, idx) => {
          if (typeof starter === "string") {
            return (
              <div key={idx} className="drStarterCard">
                <p className="drStarterLine">{starter}</p>
              </div>
            );
          }

          const angle = ANGLE_BADGES[starter.angle] || { label: starter.angle, color: "#6b7280" };
          const confidence = CONFIDENCE_STYLES[starter.confidence] || CONFIDENCE_STYLES.medium;

          return (
            <div key={idx} className="drStarterCard">
              <div className="drStarterTop">
                <span className="drAngleBadge" style={{ backgroundColor: angle.color }}>
                  {angle.label}
                </span>
                <span className="drConfidenceBadge" style={{ backgroundColor: confidence.bg, color: confidence.color }}>
                  {confidence.label}
                </span>
              </div>
              <p className="drStarterLine">{starter.line}</p>
              {starter.based_on && (
                <p className="drStarterSource">Based on: {starter.based_on}</p>
              )}
              <button className="drCopyBtn" onClick={() => copyToClipboard(starter.line)}>
                Copy
              </button>
            </div>
          );
        })}
      </div>

      <SectionSources
        serpLinks={serpLinks}
        labels={[
          "PROSPECT_THOUGHT_LEADERSHIP",
          "PROSPECT_PODCASTS_EVENTS",
          "PROSPECT_YOUTUBE_TALKS",
          "PROSPECT_NEWS_MENTIONS"
        ]}
      />
    </div>
  );
});

export default ConversationStarters;
